import React, { useState, useEffect } from "react";
import "./FindAnomaly.css";
import Navbar from "../../common/Navbar";
import * as Constants from "../../../Constants/index";
import axios from "axios";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { useFormik } from "formik";
import ResponsivePagination from "react-responsive-pagination";
// Ensure you have the css for pagination or it will look unstyled
import "react-responsive-pagination/themes/classic.css";
import Oval from "../loader/CircleLoade";

// --- Icons ---
const DashboardIcon = () => (
  <svg className="nav-icon" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="7" height="7"></rect>{" "}
    <rect x="14" y="3" width="7" height="7"></rect>{" "}
    <rect x="3" y="14" width="7" height="7"></rect>{" "}
    <rect x="14" y="14" width="7" height="7"></rect>
  </svg>
);
const AnomaliesIcon = () => (
  <svg className="nav-icon" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10"></circle>{" "}
    <line x1="12" y1="8" x2="12" y2="12"></line>{" "}
    <line x1="12" y1="16" x2="12.01" y2="16"></line>
  </svg>
);
const ReportsIcon = () => (
  <svg className="nav-icon" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2z"></path>
  </svg>
);

// --- Mock Data for Screens without API ---
const MOCK_ALERTS = [
  {
    id: "ALT-89234",
    anomalyId: "ANM-2847",
    role: "TL DG",
    channel: "Email",
    sent: "2024-01-15 09:25",
    status: "Delivered",
  },
  {
    id: "ALT-89233",
    anomalyId: "ANM-5632",
    role: "ZM DG",
    channel: "Dashboard Push",
    sent: "2024-01-14 14:30",
    status: "Delivered",
  },
  {
    id: "ALT-89232",
    anomalyId: "ANM-4156",
    role: "Program Manager",
    channel: "Email",
    sent: "2024-01-13 17:35",
    status: "Failed",
  },
  {
    id: "ALT-89231",
    anomalyId: "ANM-3421",
    role: "TL DG",
    channel: "Email",
    sent: "2024-01-14 16:44",
    status: "Delivered",
  },
  {
    id: "ALT-89230",
    anomalyId: "ANM-1923",
    role: "TL DG",
    channel: "Dashboard Push",
    sent: "2024-01-15 08:17",
    status: "Delivered",
  },
];

const MOCK_LOYALTY = [
  {
    id: "PLB-2847",
    name: "Rajesh Kumar",
    territory: "North - Delhi",
    level: "L2 - Full Verified",
    points: 2847,
    scan: "45/50",
    status: "Active",
    anomalies: "2 (Approved)",
  },
  {
    id: "PLB-1923",
    name: "Amit Sharma",
    territory: "West - Mumbai",
    level: "L2 - Full Verified",
    points: 5234,
    scan: "18/50",
    status: "Active",
    anomalies: "1 (Approved)",
  },
  {
    id: "PLB-3421",
    name: "Suresh Patel",
    territory: "South - Chennai",
    level: "L1 - Basic Verified",
    points: 1567,
    scan: "32/50",
    status: "Blocked",
    anomalies: "3 (2 Rejected)",
  },
  {
    id: "PLB-5632",
    name: "Vikram Singh",
    territory: "East - Kolkata",
    level: "L2 - Full Verified",
    points: 3921,
    scan: "27/50",
    status: "Active",
    anomalies: "1 (Pending)",
  },
  {
    id: "PLB-7234",
    name: "Mohammed Ali",
    territory: "North - Jaipur",
    level: "L2 - Full Verified",
    points: 4112,
    scan: "22/50",
    status: "Active",
    anomalies: "0",
  },
  {
    id: "PLB-4156",
    name: "Pradeep Nair",
    territory: "South - Bangalore",
    level: "L1 - Basic Verified",
    points: 967,
    scan: "38/50",
    status: "Blocked",
    anomalies: "4 (3 Rejected)",
  },
];

const App = () => {
  const [activeScreen, setActiveScreen] = useState(1);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({ isOpen: false, type: null });
  const [showSuccessBanner, setShowSuccessBanner] = useState(false);

  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [loading, setLoading] = useState(false);

  // --- Data States ---
  const [reportData, setReportData] = useState(null); // Used for Anomalies List
  const [acknowledgementData, setAcknowledgementData] = useState(null); // Used for Reports Screen
  const [anomaliesCount, setAnomaliesCount] = useState({});
  const [getAnomaliesTerritory, setAnomaliesTerritory] = useState([]);
  const [anomalyDetails, setAnomalyDetails] = useState({});

  // --- Pagination & Remarks ---
  // Anomaly Pagination
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);

  // Acknowledgement/Reports Pagination
  const [ackCurrentPage, setAckCurrentPage] = useState(1);
  const [ackTotalPages, setAckTotalPages] = useState(0);

  const [remarks, setRemarks] = useState("");

  // --- Filter States ---
  // 1. Anomaly Screen Filters
  const [anomalyFilters, setAnomalyFilters] = useState({
    startDate: null,
    endDate: null,
    mobile: "",
    status: "",
    anomalyType: "",
  });

  // 2. Reports Screen Filters
  const [reportFilters, setReportFilters] = useState({
    startDate: null,
    endDate: null,
    mobile: "", // mapping entityId/mobile
    status: "", // mapping actionType
  });

  // 3. Alerts Screen Filters (Client Side)
  const [alertFilters, setAlertFilters] = useState({
    startDate: null,
    role: "All Roles",
    channel: "All Channels",
    status: "All Status",
  });
  const [filteredAlerts, setFilteredAlerts] = useState(MOCK_ALERTS);

  // 4. Loyalty Screen Filters (Client Side)
  const [loyaltyFilters, setLoyaltyFilters] = useState({
    level: "All Levels",
    status: "All Status",
    points: "All Ranges",
  });
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [filteredLoyalty, setFilteredLoyalty] = useState(MOCK_LOYALTY);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const handleModalOpen = (type) => {
    setModalConfig({ isOpen: true, type });
  };

  const handleModalClose = () => {
    setModalConfig({ isOpen: false, type: null });
  };

  const confirmDecision = () => {
    handleModalClose();
    setShowSuccessBanner(true);
    setTimeout(() => {
      setShowSuccessBanner(false);
      setTimeout(() => setActiveScreen(2), 500);
    }, 3000);
  };

  // --- API CALLS ---

  const getAnomalyData = async (data, pageNum) => {
    setLoading(true);
    // if (!token) navigate("/"); // Commented out for demo safety

    const searchTerm =
      data?.mobile && data.mobile !== "" ? `&searchTerm=${data.mobile}` : "";
    const statusParam =
      data?.status && data.status !== "All Status"
        ? `&status=${data.status}`
        : "";

    // Note: API might expect specific type keys, adjust as needed
    const typeParam =
      data?.anomalyType && data.anomalyType !== "All Types"
        ? `&anomalyType=${data.anomalyType}`
        : "";

    let stDate = "";
    let endDate = "";

    if (data?.startDate && data?.endDate) {
      stDate = `&start=${moment(data.startDate)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss")}`;
      endDate = `&end=${moment(data.endDate)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss")}`;
    }

    axios
      .get(
        Constants.baseUrl +
          `anomaly/findAnomaly?sortBy=createdDateTime&sortAsc=false&limit=${limit}&page=${pageNum}${searchTerm}${statusParam}${typeParam}${stDate}${endDate}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program,
          },
        },
      )
      .then((res) => {
        let dt = res.data;
        if (dt.result === "success") {
          setReportData(dt.output.results);
          setTotalPages(dt.output.totalPages);
        } else {
          setReportData([]);
          setTotalPages(0);
        }
        setLoading(false);
      })
      .catch(() => {
        setReportData([]); // Fallback
        setLoading(false);
      });
  };

  const downloadAnomalyData = (data) => {
    setDownloadLoading(true);

    const searchTerm =
      data?.mobile && data.mobile !== "" ? `&searchTerm=${data.mobile}` : "";

    const status = data?.status ? `&status=${data.status}` : "";

    let stDate = "";
    let endDate = "";

    // ✅ FIXED: Full-day range for filtering
    if (data?.startDate && data?.endDate) {
      stDate = `&start=${moment(data.startDate)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss")}`;

      endDate = `&end=${moment(data.endDate)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss")}`;
    }

    axios
      .get(
        Constants.baseUrl +
          `reports/download/anomaly?${status}${searchTerm}${stDate}${endDate}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program,
          },
          responseType: "blob",
        },
      )
      .then((res) => {
        const fileData = new Blob([res.data], { type: "text/csv" });
        saveAs(fileData, "FindAnomaly.csv");
        setDownloadLoading(false);
      })
      .catch(() => setDownloadLoading(false));
  };

  const getAnomalyDataById = async (userId) => {
    setLoading(true);
    // if (!token) navigate("/");

    axios
      .get(Constants.baseUrl + `anomaly/get/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          appVersion: Constants.av,
          platform: Constants.pt,
          company: Constants.company,
          program: Constants.program,
        },
      })
      .then((res) => {
        let dt = res.data;
        if (dt.result === "success") {
          setAnomalyDetails(dt.output);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const getAnomaliesCount = async () => {
    // setLoading(true);
    axios
      .get(Constants.baseUrl + `anomaly/sales/anomaly/dashboard`, {
        headers: {
          Authorization: `Bearer ${token}`,
          appVersion: Constants.av,
          platform: Constants.pt,
          company: Constants.company,
          program: Constants.program,
        },
      })
      .then((res) => {
        let dt = res.data;
        if (dt.result === "success") {
          setAnomaliesCount(dt.output);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const getAnomaliesTerritorydatas = async () => {
    axios
      .get(Constants.baseUrl + `anomaly/sales/anomaly/groupByTerritory`, {
        headers: {
          Authorization: `Bearer ${token}`,
          appVersion: Constants.av,
          platform: Constants.pt,
          company: Constants.company,
          program: Constants.program,
        },
      })
      .then((res) => {
        let dt = res.data;
        if (dt.result === "success") {
          setAnomaliesTerritory(dt.output);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const handleStatusUpdate = (statusAction, userId) => {
    if (statusAction === "APPROVED" && !remarks.trim()) {
      swal(
        "Required",
        "Please add comments to approve this anomaly.",
        "warning",
      );
      document.getElementById("reviewerComment").focus();
      return;
    }
    if (statusAction === "BLOCKED" && !remarks.trim()) {
      swal("Required", "Please add comments to block this anomaly.", "warning");
      document.getElementById("reviewerComment").focus();
      return;
    }

    setLoading(true);

    axios
      .patch(
        Constants.baseUrl + `anomaly/approval/${userId}`,
        {
          status: statusAction,
          remarks: remarks,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program,
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        swal({
          text: `Anomaly ${
            statusAction === "APPROVED" ? "Approved" : "Rejected"
          } Successfully`,
          icon: "success",
          timer: 2000,
          buttons: false,
        });
        setRemarks("");
        // Go back to list and refresh
        setActiveScreen(2);
        getAnomalyData(anomalyFilters, currentPage);
      })
      .catch((err) => {
        swal(
          "Error!",
          err.response?.data?.message || "Unable to update status.",
          "error",
        );
      })
      .finally(() => setLoading(false));
  };

  const getAcknowledgement = async (data, pageNum) => {
    setLoading(true);

    const searchTerm =
      data?.mobile && data.mobile !== "" ? `&mobile=${data.mobile}` : "";
    const status =
      data?.status && data.status !== "All Actions"
        ? `&status=${data.status}`
        : "";

    let stDate = "";
    let endDate = "";

    if (data?.startDate && data?.endDate) {
      stDate = `&start=${moment(data.startDate)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss")}`;
      endDate = `&end=${moment(data.endDate)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss")}`;
    }

    axios
      .get(
        Constants.baseUrl +
          `reports/anomaly/acknowledgement?sortBy=createDateTime&sortAsc=true&limit=${limit}&page=${pageNum}${searchTerm}${status}${stDate}${endDate}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program,
          },
        },
      )
      .then((res) => {
        let dt = res.data;
        if (dt.result === "success") {
          setAcknowledgementData(dt.output.results);
          // Update the total pages for pagination
          setAckTotalPages(dt.output.totalPages || 0);
        } else {
          setAcknowledgementData([]);
          setAckTotalPages(0);
        }
        setLoading(false);
      })
      .catch(() => {
        setAcknowledgementData([]);
        setLoading(false);
      });
  };

  const downloadAnomalyAcknowledgement = (data) => {
    setDownloadLoading(true);

    const searchTerm =
      data?.mobile && data.mobile !== "" ? `&mobile=${data.mobile}` : "";

    const status = data?.status ? `&status=${data.status}` : "";

    let stDate = "";
    let endDate = "";

    // ✅ FIXED: Full-day range for filtering
    if (data?.startDate && data?.endDate) {
      stDate = `&start=${moment(data.startDate)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss")}`;

      endDate = `&end=${moment(data.endDate)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss")}`;
    }

    axios
      .get(
        Constants.baseUrl +
          `reports/download/anomalyAcknowledgement?${status}${searchTerm}${stDate}${endDate}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program,
          },
          responseType: "blob",
        },
      )
      .then((res) => {
        const fileData = new Blob([res.data], { type: "text/csv" });
        saveAs(fileData, "FindAnomaly.csv");
        setDownloadLoading(false);
      })
      .catch(() => setDownloadLoading(false));
  };

  // --- Initial Load ---
  useEffect(() => {
    getAnomalyData({}, 1);
    getAnomaliesCount();
    getAnomaliesTerritorydatas();
    getAcknowledgement({}, 1);
  }, []);

  // --- Client Side Filtering Logic ---
  useEffect(() => {
    // Filter Alerts
    let tempAlerts = MOCK_ALERTS;
    if (alertFilters.role !== "All Roles") {
      tempAlerts = tempAlerts.filter(
        (a) =>
          a.role.includes(alertFilters.role) ||
          alertFilters.role.includes(a.role),
      );
    }
    if (alertFilters.channel !== "All Channels") {
      tempAlerts = tempAlerts.filter((a) =>
        a.channel.includes(alertFilters.channel),
      );
    }
    if (alertFilters.status !== "All Status") {
      tempAlerts = tempAlerts.filter((a) => a.status === alertFilters.status);
    }
    if (alertFilters.startDate) {
      // Simple day matching for demo
      const filterDate = moment(alertFilters.startDate).format("YYYY-MM-DD");
      tempAlerts = tempAlerts.filter((a) => a.sent.includes(filterDate));
    }
    setFilteredAlerts(tempAlerts);

    // Filter Loyalty
    let tempLoyalty = MOCK_LOYALTY;
    if (loyaltyFilters.level !== "All Levels") {
      tempLoyalty = tempLoyalty.filter((l) => l.level === loyaltyFilters.level);
    }
    if (loyaltyFilters.status !== "All Status") {
      tempLoyalty = tempLoyalty.filter(
        (l) => l.status === loyaltyFilters.status,
      );
    }
    if (loyaltyFilters.points !== "All Ranges") {
      // Logic for point ranges
      if (loyaltyFilters.points === "0 - 1,000")
        tempLoyalty = tempLoyalty.filter((l) => l.points <= 1000);
      if (loyaltyFilters.points === "1,000 - 5,000")
        tempLoyalty = tempLoyalty.filter(
          (l) => l.points > 1000 && l.points <= 5000,
        );
      if (loyaltyFilters.points === "5,000 - 10,000")
        tempLoyalty = tempLoyalty.filter(
          (l) => l.points > 5000 && l.points <= 10000,
        );
      if (loyaltyFilters.points === "10,000+")
        tempLoyalty = tempLoyalty.filter((l) => l.points > 10000);
    }
    setFilteredLoyalty(tempLoyalty);
  }, [alertFilters, loyaltyFilters]);

  // --- Screens Render Functions ---
  // NOTE: These are changed from const Component = () => ... to const renderFunction = () => ...
  // to fix the input focus issue. If they are components defined inside App, they remount on every keypress.

  const renderDashboardScreen = () => (
    <div id="screen1" className="screen-content">
      <div className="page-header">
        <div className="breadcrumb">
          <span>Home</span> <span className="breadcrumb-separator">/</span>{" "}
          <span className="breadcrumb-current">Dashboard</span>
        </div>
        <h2 className="page-title">Dashboard Overview</h2>
        <p className="page-subtitle">
          Real-time anomaly detection monitoring and insights
        </p>
      </div>

      {/* KPI Cards */}
      <div className="kpi-grid">
        <div className="kpi-card">
          <div className="kpi-header">
            <div className="kpi-label">Total Anomalies</div>
            <div className="kpi-icon">
              <svg
                width="20"
                height="20"
                fill="none"
                stroke="#3182ce"
                strokeWidth="2"
              >
                <circle cx="10" cy="10" r="8"></circle>{" "}
                <line x1="10" y1="6" x2="10" y2="10"></line>{" "}
                <line x1="10" y1="14" x2="10.01" y2="14"></line>
              </svg>
            </div>
          </div>
          <div className="kpi-value">{anomaliesCount?.totalAnomaly || 0}</div>
        </div>
        <div className="kpi-card">
          <div className="kpi-header">
            <div className="kpi-label">Pending Reviews</div>
            <div className="kpi-icon">
              <svg
                width="20"
                height="20"
                fill="none"
                stroke="#3182ce"
                strokeWidth="2"
              >
                <circle cx="10" cy="10" r="8"></circle>{" "}
                <path d="M10 6v4l3 2"></path>
              </svg>
            </div>
          </div>
          <div className="kpi-value">{anomaliesCount?.pending || 0}</div>
        </div>
        <div className="kpi-card">
          <div className="kpi-header">
            <div className="kpi-label">Approved Cases</div>
            <div className="kpi-icon">
              <svg
                width="20"
                height="20"
                fill="none"
                stroke="#3182ce"
                strokeWidth="2"
              >
                <path d="M9 10l2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"></path>
              </svg>
            </div>
          </div>
          <div className="kpi-value">{anomaliesCount?.approved || 0}</div>
        </div>
        <div className="kpi-card">
          <div className="kpi-header">
            <div className="kpi-label">Rejected / Blocked</div>
            <div className="kpi-icon">
              <svg
                width="20"
                height="20"
                fill="none"
                stroke="#3182ce"
                strokeWidth="2"
              >
                <circle cx="10" cy="10" r="8"></circle>{" "}
                <line x1="6" y1="10" x2="14" y2="10"></line>
              </svg>
            </div>
          </div>
          <div className="kpi-value">{anomaliesCount?.blocked || 0}</div>
        </div>
      </div>

      {/* Territory Table */}
      <div className="table-container">
        <div className="table-header">
          <h3 className="table-title">Anomalies by Territory</h3>
        </div>
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Territory</th>
                <th>Total Anomalies</th>
                <th>Pending</th>
                <th>Approved</th>
                <th>Rejected</th>
              </tr>
            </thead>
            <tbody>
              {getAnomaliesTerritory.map((territory, idx) => (
                <tr className="flagged" key={idx}>
                  <td>
                    <strong>{territory.territoryCode}</strong>
                  </td>
                  <td>{territory.total}</td>
                  <td>{territory.pending}</td>
                  <td>{territory.approved}</td>
                  <td>{territory.rejected}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  const renderAnomaliesScreen = () => (
    <div id="screen2" className="screen-content">
      <div className="page-header">
        <div className="breadcrumb">
          <span>Home</span> <span className="breadcrumb-separator">/</span>{" "}
          <span className="breadcrumb-current">Anomalies</span>
        </div>
        <h2 className="page-title">Anomaly Detection List</h2>
        <p className="page-subtitle">
          Monitor and review all detected anomalies
        </p>
      </div>

      <div className="filters-panel">
        <div className="filters-grid">
          {/* Working Date Filters */}
          <div className="filter-group">
            <label className="filter-label">Start Date</label>
            <DatePicker
              selected={anomalyFilters.startDate}
              onChange={(date) =>
                setAnomalyFilters({ ...anomalyFilters, startDate: date })
              }
              className="filter-input"
              placeholderText="Start Date"
              dateFormat="yyyy-MM-dd"
            />
          </div>
          <div className="filter-group">
            <label className="filter-label">End Date</label>
            <DatePicker
              selected={anomalyFilters.endDate}
              onChange={(date) =>
                setAnomalyFilters({ ...anomalyFilters, endDate: date })
              }
              className="filter-input"
              placeholderText="End Date"
              dateFormat="yyyy-MM-dd"
            />
          </div>

          <div className="filter-group">
            <label htmlFor="phoneNumber" className="filter-label">
              Mobile Number
            </label>
            <input
              type="text"
              id="phoneNumber"
              className="filter-input"
              placeholder="Search by mobile number"
              value={anomalyFilters.mobile || ""}
              onChange={(e) =>
                setAnomalyFilters((prev) => ({
                  ...prev,
                  mobile: e.target.value,
                }))
              }
            />
          </div>
          <div className="filter-group">
            <label htmlFor="status" className="filter-label">
              Status
            </label>
            <select
              id="status"
              className="filter-input"
              value={anomalyFilters.status}
              onChange={(e) =>
                setAnomalyFilters({ ...anomalyFilters, status: e.target.value })
              }
            >
              <option>All Status</option>
              <option value="PENDING">Pending</option>
              <option value="APPROVED">Approved</option>
              <option value="BLOCKED">Blocked</option>
            </select>
          </div>
        </div>
        <div className="filter-actions">
          <button
            className="apply-filters-btn"
            onClick={() => {
              setCurrentPage(1);
              getAnomalyData(anomalyFilters, 1);
            }}
          >
            Apply Filters
          </button>
          <button
            className="reset-filters-btn"
            onClick={() => {
              const emptyFilters = {
                startDate: null,
                endDate: null,
                mobile: "",
                status: "",
                anomalyType: "",
              };
              setAnomalyFilters(emptyFilters);
              getAnomalyData(emptyFilters, 1);
            }}
          >
            Reset
          </button>
        </div>
      </div>

      <div className="table-container">
        <div className="table-header">
          <h3 className="table-title">
            Detected Anomalies ({reportData?.length || 0} Results)
          </h3>
          <div className="table-actions">
            <button
              className="table-action-btn"
              onClick={() => downloadAnomalyData(anomalyFilters)}
              style={{
                padding: "12px 24px",
                backgroundColor: "#007bff",
                color: "white",
                border: "none",
                borderRadius: "4px",
              }}
            >
              Export
            </button>
          </div>
        </div>
        <div className="table-wrapper">
          {loading ? (
            <div style={{ padding: "20px", textAlign: "center" }}>
              Loading data...
            </div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>User ID</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  {/* <th>Purchase Value</th> */}
                  {/* <th>Value</th> */}
                  <th>Anomaly Type</th>
                  <th>Sub Type</th>
                  {/* <th>QR Trans Id</th>
                <th>Claim Id</th> */}
                  <th>Remark</th>
                  <th>Created</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              {reportData && reportData.length > 0 ? (
                <tbody>
                  {reportData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(currentPage - 1) * limit + index + 1}</td>
                      <td>{item.userId}</td>
                      <td>{item.name}</td>
                      <td>{item.mobile}</td>
                      {/* <td>{item.purchaseValue}</td> */}
                      {/* {<td>{item.value}</td>} */}
                      <td>{item.anomalyType}</td>
                      <td>{item.anomalySubType}</td>
                      {/* <td>{item.qrTransId}</td>
                    <td>{item.claimId}</td> */}
                      <td>{item.remarks}</td>
                      <td>
                        {moment(item.createdDateTime).format(
                          "DD-MM-YYYY HH:mm",
                        )}
                      </td>
                      <td>
                        <span
                          className={`status-badge ${
                            item.status === "APPROVED"
                              ? "status-approved"
                              : item.status === "REJECTED"
                                ? "status-rejected"
                                : "status-pending"
                          }`}
                        >
                          {item.status}
                        </span>
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-primary"
                          style={{
                            backgroundColor: "#3182ce",
                            color: "white",
                            border: "none",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setActiveScreen(3);
                            getAnomalyDataById(item.id);
                          }}
                        >
                          {item.status === "PENDING"
                            ? "Take Action"
                            : "View Details"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan="12" style={{ textAlign: "center" }}>
                      No records found
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          )}
        </div>
        {/* PAGINATION FOR ANOMALIES */}
        <div style={{ marginTop: "20px" }}>
          <ResponsivePagination
            current={currentPage}
            total={totalPages}
            onPageChange={(page) => {
              setCurrentPage(page);
              getAnomalyData(anomalyFilters, page);
            }}
          />
        </div>
      </div>
    </div>
  );

  const renderReviewScreen = () => (
    <div id="screen3" className="screen-content">
      <div className="page-header">
        <div className="breadcrumb">
          <span>Home</span> <span className="breadcrumb-separator">/</span>{" "}
          <span>Anomalies</span> <span className="breadcrumb-separator">/</span>{" "}
          <span className="breadcrumb-current">Review</span>
        </div>
        <h2 className="page-title">Anomaly Review &amp; Decision</h2>
        <p className="page-subtitle">
          Case ID: {anomalyDetails?.anomaly?.id || "N/A"}
        </p>
      </div>

      {/* Success Banner */}
      <div
        className={`success-banner ${showSuccessBanner ? "active" : ""}`}
        id="successBanner"
      >
        <span className="success-text">Decision submitted successfully!</span>
      </div>

      <div className="review-layout">
        {/* Left Panel: Plumber Profile */}
        <div className="review-panel">
          <h3 className="panel-title">User Profile</h3>
          <div className="detail-row">
            <span className="detail-label">User ID</span>{" "}
            <span className="detail-value">{anomalyDetails?.user?.id}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Name</span>{" "}
            <span className="detail-value">
              {anomalyDetails?.anomaly?.name}
            </span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Mobile</span>{" "}
            <span className="detail-value">
              {anomalyDetails?.anomaly?.mobile}
            </span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Registration Date</span>{" "}
            <span className="detail-value">
              {anomalyDetails?.user?.createDateTime}
            </span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Account Status</span>{" "}
            <span className="detail-value">
              <span className="status-badge status-active">
                {anomalyDetails?.user?.deleted ? "Blocked" : "Unblocked"}
              </span>
            </span>
          </div>
          {/* Territory (Your existing row) */}
          <div className="detail-row">
            <span className="detail-label">Territory</span>
            <span className="detail-value">
              {anomalyDetails?.user?.territoryName || "-"}
            </span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Zone</span>{" "}
            <span className="detail-value">{anomalyDetails?.user?.zone}</span>
          </div>

          {/* Branch */}
          <div className="detail-row">
            <span className="detail-label">Branch</span>
            <span className="detail-value">
              {anomalyDetails?.user?.branch || "-"}
            </span>
          </div>

          {/* FS Details (Missing in API) */}
          <div className="detail-row">
            <span className="detail-label">FS Name</span>
            <span className="detail-value">
              {anomalyDetails?.user?.fsName || "-"}
            </span>
          </div>

          <div className="detail-row">
            <span className="detail-label">FS Mobile</span>
            <span className="detail-value">
              {anomalyDetails?.user?.fsMobile || "-"}
            </span>
          </div>

          <div className="detail-row">
            <span className="detail-label">FS Code</span>
            <span className="detail-value">
              {anomalyDetails?.user?.fsCode || "-"}
            </span>
          </div>
        </div>

        {/* Center Panel: Anomaly Details */}
        <div className="review-panel">
          <h3 className="panel-title">Anomaly Details</h3>
          <div className="detail-row">
            <span className="detail-label">Anomaly ID</span>{" "}
            <span className="detail-value">{anomalyDetails?.anomaly?.id}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Anomaly Type</span>{" "}
            <span className="detail-value">
              {anomalyDetails?.anomaly?.anomalyType}
            </span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Sub Type</span>{" "}
            <span className="detail-value">
              {anomalyDetails?.anomaly?.anomalySubType}
            </span>
          </div>

          {/*
          <div className="detail-row">
            <span className="detail-label">Actual Value</span>{" "}
            <span className="detail-value">
              {anomalyDetails?.anomaly?.value}
            </span>
          </div>
*/}
          {/* QR Type */}
          {anomalyDetails?.anomaly?.anomalyType === "QR" && (
            <>
              <div className="detail-row">
                <span className="detail-label">Volume</span>
                <span className="detail-value">
                  {anomalyDetails?.anomaly?.value ?? 0}
                </span>
              </div>
              {/*
              <div className="detail-row">
                <span className="detail-label">Purchase Value</span>
                <span className="detail-value">
                  {anomalyDetails?.anomaly?.purchaseValue ?? 0}
                </span>
              </div>
*/}
              <div className="detail-row">
                <span className="detail-label">Limit Value</span>
                <span className="detail-value">
                  {anomalyDetails?.anomaly?.anomalyLimitvalue ?? 0}
                </span>
              </div>
            </>
          )}

          {/* CLAIM Type */}
          {anomalyDetails?.anomaly?.anomalyType === "CLAIM" && (
            <>
              <div className="detail-row">
                <span className="detail-label">Claim ID</span>
                <span className="detail-value">
                  {anomalyDetails?.anomaly?.claimId ?? 0}
                </span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Purchase Value</span>
                <span className="detail-value">
                  {anomalyDetails?.anomaly?.purchaseValue ?? 0}
                </span>
              </div>

              <div className="detail-row">
                <span className="detail-label">Limit Value</span>
                <span className="detail-value">
                  {anomalyDetails?.anomaly?.anomalyLimitvalue ?? 0}
                </span>
              </div>
            </>
          )}

          <div className="detail-row">
            <span className="detail-label">Detection Time</span>{" "}
            <span className="detail-value">
              {moment(anomalyDetails?.anomaly?.createdDateTime).format(
                "DD MMM YYYY, HH:mm",
              )}
            </span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Current Status</span>{" "}
            <span className="detail-value">
              <span
                className={`status-badge ${
                  anomalyDetails?.anomaly?.status === "APPROVED"
                    ? "status-approved"
                    : "status-rejected"
                }`}
              >
                {anomalyDetails?.anomaly?.status}
              </span>
            </span>
          </div>
        </div>

        {/* Right Panel: Action Box */}
        <div className="review-panel">
          <h3 className="panel-title">Decision &amp; Action</h3>
          {anomalyDetails?.anomaly?.status === "PENDING" ? (
            <>
              <p
                style={{
                  fontSize: "13px",
                  color: "#718096",
                  marginBottom: "16px",
                }}
              >
                Review the anomaly details. Add comments to document your
                reasoning.
              </p>
              <div className="filter-group">
                <label htmlFor="reviewerComment" className="filter-label">
                  Decision Comments
                </label>
                <textarea
                  id="reviewerComment"
                  className="comment-box"
                  placeholder="Add your comments here... (Mandatory for rejection)"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  disabled={loading}
                ></textarea>
              </div>

              <div className="decision-buttons">
                <button
                  className="approve-btn"
                  onClick={() =>
                    handleStatusUpdate("APPROVED", anomalyDetails?.anomaly?.id)
                  }
                  disabled={loading}
                >
                  Approve
                </button>
                <button
                  className="reject-btn"
                  onClick={() =>
                    handleStatusUpdate("BLOCKED", anomalyDetails?.anomaly?.id)
                  }
                  disabled={loading}
                >
                  Block
                </button>
              </div>
            </>
          ) : (
            <div>
              <p>
                <strong>Decision:</strong> {anomalyDetails?.anomaly?.status}
              </p>
              <p>
                <strong>Remarks:</strong>{" "}
                {anomalyDetails?.anomaly?.remarks || "No remarks"}
              </p>
              <button
                className="btn btn-primary"
                onClick={() => setActiveScreen(2)}
                style={{ marginTop: "20px" }}
              >
                Back to List
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderAlertsScreen = () => (
    <div id="screen4" className="screen-content">
      <div className="page-header">
        <div className="breadcrumb">
          <span>Home</span> <span className="breadcrumb-separator">/</span>{" "}
          <span className="breadcrumb-current">Alerts &amp; Notifications</span>
        </div>
        <h2 className="page-title">Alerts &amp; Notifications</h2>
        <p className="page-subtitle">
          Track alert delivery and notification status
        </p>
      </div>

      <div className="filters-panel">
        <div className="filters-grid">
          <div className="filter-group">
            <label className="filter-label">Date Filter</label>{" "}
            <DatePicker
              selected={alertFilters.startDate}
              onChange={(date) =>
                setAlertFilters({ ...alertFilters, startDate: date })
              }
              className="filter-input"
              placeholderText="Select Date"
            />
          </div>
          <div className="filter-group">
            <label htmlFor="recipient" className="filter-label">
              Recipient Role
            </label>{" "}
            <select
              id="recipient"
              className="filter-input"
              value={alertFilters.role}
              onChange={(e) =>
                setAlertFilters({ ...alertFilters, role: e.target.value })
              }
            >
              <option>All Roles</option>
              <option>TL DG</option> <option>ZM DG</option>
              <option>Program Manager</option>{" "}
            </select>
          </div>
          <div className="filter-group">
            <label htmlFor="channel" className="filter-label">
              Channel
            </label>{" "}
            <select
              id="channel"
              className="filter-input"
              value={alertFilters.channel}
              onChange={(e) =>
                setAlertFilters({ ...alertFilters, channel: e.target.value })
              }
            >
              <option>All Channels</option>
              <option>Email</option> <option>Dashboard Push</option>{" "}
            </select>
          </div>
          <div className="filter-group">
            <label htmlFor="deliveryStatus" className="filter-label">
              Delivery Status
            </label>{" "}
            <select
              id="deliveryStatus"
              className="filter-input"
              value={alertFilters.status}
              onChange={(e) =>
                setAlertFilters({ ...alertFilters, status: e.target.value })
              }
            >
              <option>All Status</option>
              <option>Delivered</option>
              <option>Failed</option>{" "}
            </select>
          </div>
        </div>
        <div className="filter-actions">
          {/* Client side filtering is immediate via useEffect, but we keep button for consistency */}
          <button
            className="reset-filters-btn"
            onClick={() =>
              setAlertFilters({
                startDate: null,
                role: "All Roles",
                channel: "All Channels",
                status: "All Status",
              })
            }
          >
            Reset
          </button>
        </div>
      </div>

      <div className="table-container">
        <div className="table-header">
          <h3 className="table-title">
            Alert Log ({filteredAlerts.length} Total)
          </h3>
        </div>
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Alert ID</th>
                <th>Anomaly ID</th>
                <th>Recipient Role</th>
                <th>Channel</th>
                <th>Sent Timestamp</th>
                <th>Delivery Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredAlerts.length > 0 ? (
                filteredAlerts.map((alert) => (
                  <tr key={alert.id}>
                    <td>{alert.id}</td>
                    <td>{alert.anomalyId}</td>
                    <td>{alert.role}</td>
                    <td>{alert.channel}</td>
                    <td>{alert.sent}</td>
                    <td>
                      <span
                        className={`status-badge ${
                          alert.status === "Delivered"
                            ? "status-approved"
                            : "status-rejected"
                        }`}
                      >
                        {alert.status}
                      </span>
                    </td>
                    <td>
                      <button className="action-btn secondary">View</button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    No alerts matching filters
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  const renderReportsScreen = () => (
    <div id="screen5" className="screen-content">
      <div className="page-header">
        <div className="breadcrumb">
          <span>Home</span> <span className="breadcrumb-separator">/</span>{" "}
          <span className="breadcrumb-current">Reports &amp; Audit Logs</span>
        </div>
        <h2 className="page-title">Reports &amp; Audit Logs</h2>
        <p className="page-subtitle">
          Compliance tracking and full traceability
        </p>
      </div>
      <div className="filters-panel">
        <div className="filters-grid">
          <div className="filter-group">
            <label className="filter-label">Start Date</label>{" "}
            <DatePicker
              selected={reportFilters.startDate}
              onChange={(date) =>
                setReportFilters({ ...reportFilters, startDate: date })
              }
              className="filter-input"
              placeholderText="Start Date"
            />
          </div>
          <div className="filter-group">
            <label className="filter-label">End Date</label>{" "}
            <DatePicker
              selected={reportFilters.endDate}
              onChange={(date) =>
                setReportFilters({ ...reportFilters, endDate: date })
              }
              className="filter-input"
              placeholderText="End Date"
            />
          </div>
          <div className="filter-group">
            <label htmlFor="actionType" className="filter-label">
              Action Type
            </label>{" "}
            <select
              id="actionType"
              className="filter-input"
              value={reportFilters.status}
              onChange={(e) =>
                setReportFilters({ ...reportFilters, status: e.target.value })
              }
            >
              <option>All Actions</option>
              <option value="APPROVED">Approved</option>{" "}
              <option value="BLOCKED">Blocked</option>
            </select>
          </div>
          <div className="filter-group">
            <label htmlFor="phoneNumber" className="filter-label">
              Search
            </label>{" "}
            <input
              type="text"
              id="phoneNumber"
              className="filter-input"
              placeholder="Mobile Number"
              value={reportFilters.mobile || ""}
              onChange={(e) =>
                setReportFilters((prev) => ({
                  ...prev,
                  mobile: e.target.value,
                }))
              }
            />
          </div>
        </div>
        <div className="filter-actions">
          <button
            className="apply-filters-btn"
            onClick={() => {
              setAckCurrentPage(1);
              getAcknowledgement(reportFilters, 1);
            }}
          >
            Apply Filters
          </button>{" "}
          <button
            className="reset-filters-btn"
            onClick={() => {
              const empty = {
                startDate: null,
                endDate: null,
                mobile: "",
                status: "",
              };
              setReportFilters(empty);
              getAcknowledgement(empty, 1);
            }}
          >
            Reset
          </button>
        </div>
      </div>
      <div className="chart-container">
        <div className="chart-header">
          <h3 className="chart-title">Export Reports</h3>
        </div>
        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
          <button
            className="table-action-btn"
            style={{
              padding: "12px 24px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "4px",
            }}
            onClick={() => downloadAnomalyAcknowledgement(reportFilters)}
          >
            Export as CSV
          </button>
        </div>
      </div>
      <div className="table-container">
        <div className="table-header">
          <h3 className="table-title">Audit Trail</h3>
        </div>
        <div className="table-wrapper">
          {loading ? (
            <div>Loading...</div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Acknowledgement ID</th>
                  <th>Anomaly ID</th>
                  <th>Plumber Name</th>
                  <th>Plumber Mobile</th>
                  <th>Anomaly Type</th>
                  <th>Anomaly Sub Type</th>
                  <th>Purchase Value</th>
                  <th>Value</th>
                  <th>QR Transaction Id</th>
                  <th>Claim Id</th>
                  <th>Action Status</th>
                  <th>Previous Status</th>
                  <th>Ack Remarks</th>
                  <th>Action By Name</th>
                  <th>Action By Mobile</th>
                  <th>Anomaly Created Date</th>
                  <th>Action Date</th>
                </tr>
              </thead>
              <tbody>
                {acknowledgementData && acknowledgementData.length > 0 ? (
                  acknowledgementData.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row[0]}</td>
                      <td>{row[1]}</td>
                      <td>{row[2]}</td>
                      <td>{row[3]}</td>
                      <td>{row[4]}</td>
                      <td>{row[5]}</td>
                      <td>{row[6]}</td>
                      <td>{row[7]}</td>
                      <td>{row[8]}</td>
                      <td>{row[9]}</td>
                      <td>{row[10]}</td>
                      <td>{row[11]}</td>
                      <td>{row[12]}</td>
                      <td>{row[13]}</td>
                      <td>{row[14]}</td>
                      <td>{moment(row[15]).format("DD-MM-YYYY HH:mm")}</td>
                      <td>{moment(row[16]).format("DD-MM-YYYY HH:mm")}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="17" style={{ textAlign: "center" }}>
                      No audit logs found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        {/* PAGINATION FOR REPORTS */}
        <div style={{ marginTop: "20px" }}>
          <ResponsivePagination
            current={ackCurrentPage}
            total={ackTotalPages}
            onPageChange={(page) => {
              setAckCurrentPage(page);
              getAcknowledgement(reportFilters, page);
            }}
          />
        </div>
      </div>
    </div>
  );

  const renderContent = () => {
    switch (activeScreen) {
      case 1:
        return renderDashboardScreen();
      case 2:
        return renderAnomaliesScreen();
      case 3:
        return renderReviewScreen();
      case 4:
        return renderAlertsScreen();
      case 5:
        return renderReportsScreen();
      default:
        return renderDashboardScreen();
    }
  };

  return (
    <div className="portal-wrapper">
      <Navbar />

      <nav
        className={`sidebar ${isSidebarOpen ? "mobile-open" : ""}`}
        id="sidebar"
      >
        <div className="nav-section">
          <div className="nav-section-title">Main Menu</div>
          <div
            className={`nav-item ${activeScreen === 1 ? "active" : ""}`}
            onClick={() => setActiveScreen(1)}
          >
            <DashboardIcon /> Dashboard
          </div>
          <div
            className={`nav-item ${activeScreen === 2 ? "active" : ""}`}
            onClick={() => setActiveScreen(2)}
          >
            <AnomaliesIcon /> Anomalies
          </div>
        </div>
        <div className="nav-section">
          <div className="nav-section-title">Administration</div>
          <div
            className={`nav-item ${activeScreen === 5 ? "active" : ""}`}
            onClick={() => setActiveScreen(5)}
          >
            <ReportsIcon /> Reports &amp; Audit Logs
          </div>
        </div>
      </nav>

      <main className="main-content" id="mainContent">
        {renderContent()}
      </main>
    </div>
  );
};

export default App;
